import { render } from "./AdminPage.vue?vue&type=template&id=7b419274&ts=true"
import script from "./AdminPage.vue?vue&type=script&lang=ts"
export * from "./AdminPage.vue?vue&type=script&lang=ts"

import "./AdminPage.vue?vue&type=style&index=0&id=7b419274&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__